import EzController from 'controllers/ez-base-controller';
import initTooltips from 'lib/utils/tooltips';
import { triggerCustomEvent } from 'lib/helpers';
import { SBI_LOAD_FORM_ERRORS, SBI_CLEAR_DRAG_DROP } from 'lib/ez-custom-events';
import { ajaxGet } from 'lib/ajax-helpers';

const SBI_LOADING_SPINNER_HTML = '<div class="ez-spinner ez-spinner--color-mono"></div>';

export default class SearchByImageController extends EzController {
  static targets = [
    'searchInput',
    'triggerParent',
    'target',
  ];

  static values = {
    verticalOffset: Number,
    placeholder: String,
  };

  connect() {
    initTooltips('.search-by-image__open', {
      extraWrapperClass: 'search-by-image-trigger-tooltip',
    });

    this.initSearchByImage();
  }

  disconnect() {
    this.searchByImageTooltipInitialized = false;
  }

  mobileTriggerSearchByImage = () => {
    this.targetTarget.click();
  }

  loadSearchByImageForm() {
    // Wait a tick to let tippy do it's thing
    // and then check to see if we've already fetched this.
    setTimeout(() => {
      if (!this.popper?.querySelector('.search-by-image__choose-file__url-area')) {
        ajaxGet('/search_by_image_form',
          (response) => {
            this.popper.querySelector('.tippy-content').innerHTML = response.data; // eslint-disable-line no-unused-vars, no-undef
          },
          () => {
            this.loadSearchByImageFormError();
          });
      }
    });

    if (this.hasTriggerParentTarget) {
      this.triggerParentTarget.classList.add('has-search-by-image-ui');
    }

    if (this.hasSearchInputTarget) {
      this.backupSearchPlaceholder = this.searchInputTarget.placeholder;

      this.searchInputTarget.placeholder = this.placeholderValue;
    }
  }

  hideSearchByImageForm(instanceTarget) {
    instanceTarget.classList.remove('is-active');

    if (this.hasTriggerParentTarget) {
      this.triggerParentTarget.classList.remove('has-search-by-image-ui');
    }

    if (this.hasSearchInputTarget) {
      this.searchInputTarget.placeholder = this.backupSearchPlaceholder;
    }

    if (this.element.querySelector('.search-by-image__choose-file__url-area')) {
      this.element.removeAttribute('data-disable-form-submit');

      this.clearSearchByImageDragDrop();
    }
  }

  initSearchByImage() {
    if (!this.searchByImageTooltipInitialized) {
      const controller = this;
      const triggerParent = this.hasTriggerParentTarget ? this.triggerParentTarget : 'parent';

      import('tippy.js').then((tippyImport) => {
        const tippy = tippyImport.default;

        tippy(this.targetTargets, {
          content: SBI_LOADING_SPINNER_HTML,
          allowHTML: true,
          animation: 'rising',
          interactive: true,
          appendTo: triggerParent,
          placement: 'bottom-end',
          theme: 'search-by-image',
          delay: [0, null],
          duration: 0,
          maxWidth: 'none',
          offset: [0, 10],
          trigger: 'click',
          popperOptions: {
            modifiers: [
              { name: 'flip', enabled: false },
            ],
          },
          onCreate(instance) {
            instance.popper.classList.add('search-by-image-tooltip');
          },
          onTrigger(instance, event) {
            controller.element.setAttribute('data-disable-form-submit', true);
            controller.urlField = instance.popper.querySelector('[data-search-by-image-target="urlField"]');

            this.instanceTarget = event.currentTarget;

            this.instanceTarget.classList.add('is-active');
          },
          onShow(instance) {
            controller.popper = instance.popper;

            controller.loadSearchByImageForm();
          },
          onHide(instance) {
            controller.popper = instance.popper;

            controller.hideSearchByImageForm(this.instanceTarget);
          },
        });

        this.searchByImageTooltipInitialized = true;
      });
    }
  }

  loadSearchByImageFormError = () => {
    triggerCustomEvent(SBI_LOAD_FORM_ERRORS);
  }

  clearSearchByImageDragDrop = () => {
    triggerCustomEvent(SBI_CLEAR_DRAG_DROP);
  }
}
